<template>
  <div class="brainGames">
    <a-card class="tab">
      <a-tabs default-active-key="4" @change="callback">
        <a-tab-pane key="4" tab="专注与放松"></a-tab-pane>
        <a-tab-pane key="6" tab="神经反馈"></a-tab-pane>
      </a-tabs>
    </a-card>
    <a-card style="margin-top: 15px">
      <div @keyup.enter="getList(1)">
        <a-form-model layout="inline">
          <a-form-model-item label="游戏名称">
            <a-input placeholder="请输入" allow-clear v-model.trim="searchForm.name" />
          </a-form-model-item>

          <a-form-model-item>
            <a-button type="primary" @click="getList(1)">查询</a-button>
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary" @click="add.visible = true" icon="plus">添加游戏</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>

      <div style="overflow: auto; margin-top: 15px">
        <a-table
          style="min-width: 800px"
          :columns="columns"
          @change="handleTableChange"
          :pagination="tableRelevant.tablePagination"
          :loading="tableRelevant.tableLoading"
          :locale="tableRelevant.locale"
          :dataSource="tableRelevant.tableDataSource"
        >
          <div slot="index" slot-scope="text, record, index">
            {{ index + 1 }}
          </div>
          <div slot="enabled" slot-scope="text">
            <a-switch @change="tableStatusChange(text)" v-model="text.enabled" checked-children="启用" un-checked-children="禁用" />
          </div>
          <div slot="action" class="action" slot-scope="text">
            <a @click="edit(text)">编辑</a>
            <a-popconfirm title="确定删除？" @confirm="deleteItem(text)">
              <a style="color: #f00">删除</a>
            </a-popconfirm>
          </div>
        </a-table>
      </div>
    </a-card>

    <!-- 添加游戏 -->
    <a-modal v-model="add.visible" :title="add.tit" :confirmLoading="add.confirmLoading" :destroyOnClose="true" @ok="Submit" @cancel="cancelSubmit">
      <a-form-model ref="addForm" style="max-height: 450px; overflow-y: auto" :labelCol="{ span: 6 }" :wrapperCol="{ span: 17 }" :model="add.form" :rules="add.rules">
        <a-form-model-item ref="coverPlanUri" prop="coverPlanUri" label="icon" style="margin-bottom: 5px" class="icon">
          <div class="iconUpload">
            <a-upload name="imgFile" list-type="picture-card" class="avatar-uploader" :show-upload-list="false" :headers="headers" :action="baseURL" @change="changeIcon" :before-upload="beforeIcon">
              <div v-if="add.form.coverPlanUri">
                <a-icon v-show="imgLoading" style="position: absolute; top: 45%; left: 45%" type="loading" />
                <img style="width: 150px; height: 150px" :src="add.form.coverPlanUri | filterUrl" alt="avatar" />
              </div>
              <div v-else>
                <a-icon :type="iconloading ? 'loading' : 'plus'" />
              </div>
            </a-upload>
          </div>
        </a-form-model-item>
        <a-form-model-item label="游戏名称" ref="name" prop="name">
          <a-input v-model="add.form.name" @change="(e) => (add.form.name = e.target.value.replace(/\s*/g, ''))" />
        </a-form-model-item>
        <a-form-model-item label="游戏类型" ref="gameType" prop="gameType">
          <a-radio-group v-model="add.form.gameType" :options="gameTypeOptions" @change="changeGramType" />
        </a-form-model-item>
        <a-form-model-item label="游戏人数" ref="maxUser" prop="maxUser" v-if="add.form.gameType">
          <a-input-number
            v-if="[1].includes(add.form.gameType)"
            :disabled="add.form.gameType == 1"
            style="width: 140px; text-align: center"
            placeholder="人数"
            type="number"
            :precision="0"
            :min="1"
            :max="20"
            v-model="add.form.maxUser"
          />
          <a-input-group compact v-if="[2, 3].includes(add.form.gameType)">
            <a-input-number :disabled="add.form.gameType == 1" style="width: 140px; text-align: center" placeholder="人数" type="number" :precision="0" :min="1" :max="20" v-model="add.form.minUser" />
            <a-input style="width: 44px; border-left: 0; pointer-events: none; backgroundcolor: #fff" placeholder="~" disabled />
            <a-input-number
              :disabled="add.form.gameType == 1"
              style="width: 140px; text-align: center; border-left: none"
              placeholder="人数"
              :precision="0"
              :min="add.form.minUser"
              :max="20"
              type="number"
              v-model="add.form.maxUser"
            />
          </a-input-group>
        </a-form-model-item>
        <a-form-model-item label="版本号" ref="version" prop="version">
          <a-input v-model="add.form.version" :maxLength="35" @change="(e) => (add.form.version = e.target.value.replace(/\s*/g, ''))" />
        </a-form-model-item>
        <a-form-model-item label="OSS 地址" ref="uri" prop="uri">
          <a-input v-model="add.form.uri" @change="(e) => (add.form.uri = e.target.value.replace(/\s*/g, ''))" />
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-input v-model="add.form.remark" type="textarea" :maxLength="500" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-switch v-model="add.form.enabled" checked-children="启用" un-checked-children="禁用" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import Apis from '@/requests/apis'
import { tableRelevant } from '@/pages/projectImpl/js/utils'
function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

const columns = [
  { title: '排序', scopedSlots: { customRender: 'index' } },
  { title: '游戏名称', dataIndex: 'name' },
  { title: '版本号', dataIndex: 'version' },
  { title: '备注', dataIndex: 'remark', width: 250, ellipsis: true },
  { title: '状态', scopedSlots: { customRender: 'enabled' } },
  { title: '更新时间', dataIndex: 'updateTime', sorter: true },
  { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center' },
]

export default {
  data() {
    return {
      step: 1,
      gameTypeOptions: [
        { label: '单人', value: 1 },
        { label: '合作', value: 2 },
        { label: '对抗', value: 3 },
      ],
      currentType: 4,
      searchForm: {
        name: '',
      },
      columns,
      tableRelevant: tableRelevant.call(this, this.getList),
      // icon
      iconloading: false,
      imgLoading: false,
      baseURL: process.env.VUE_APP_API_BASE_URL + Apis.File.upload + '?filePath=content/game/traing',
      headers: {
        Authorization: '',
      },
      add: {
        tit: '添加游戏',
        visible: false,
        confirmLoading: false,
        form: {
          coverPlanUri: '',
          name: '',
          version: '',
          remark: '',
          enabled: true,
          minUser: 1,
          maxUser: 1,
          gameType: 1,
        },
        rules: {
          gameType: [{ required: true, message: '请选择游戏类型', trigger: 'blur' }],
          coverPlanUri: [{ required: true, message: '请选择 icon', trigger: 'blur' }],
          name: [
            { required: true, message: '请输入游戏名称', trigger: 'blur' },
            { min: 2, max: 35, message: '游戏名称长度 2 到 35 个字符', trigger: 'blur' },
          ],
          version: [{ required: true, message: '请输入版本号', trigger: 'blur' }],
          uri: [{ required: true, message: '请输入 OSS 地址', trigger: 'blur' }],
          maxUser: [
            { required: true, message: '请输入游戏人数', trigger: 'blur' },
            {
              validator: (_, val, cb) => {
                const { maxUser, minUser } = this.add.form
                if (!minUser || !maxUser) {
                  return cb(new Error('请输入游戏人数'))
                }
                return cb()
              },
            },
          ],
        },
      },
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    changeGramType(e) {
      const val = e.target.value
      this.add.form.minUser = 1
      this.add.form.maxUser = 1
      switch (val) {
        case 1:
          this.add.form.minUser = 1
          this.add.form.maxUser = 1
          break
        case 2:
          break
        case 3:
          this.add.form.minUser = 1
          this.add.form.maxUser = 1
          break
      }
    },
    callback(e) {
      this.currentType = e
      this.getList(1)
    },
    handleTableChange(pagination, filters, sorter) {
      if (sorter.order == 'ascend') {
        this.searchForm.IsDesc = true
        this.getList(1)
      } else if (sorter.order == 'descend') {
        this.searchForm.IsDesc = false
        this.getList(1)
      } else {
        this.searchForm.IsDesc = undefined
      }
    },
    getList(pageIndex) {
      let params = {
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        type: this.currentType,
        ...this.searchForm,
      }
      this.tableRelevant.tableLoading = true
      this.$http.Brain.getBrainGamesList(params, '2.0').then((res) => {
        const { data } = res
        this.tableRelevant.tableDataSource = data.items
        this.tableRelevant.tablePagination.total = data.totalCount
        this.tableRelevant.tablePagination.current = data.pageIndex
      }).finally(() => {
        this.tableRelevant.tableLoading = false
      })
    },
    addBrain() {
      this.add.tit = '添加游戏'
      this.add.visible = true
    },

    edit(text) {
      this.add.tit = '编辑游戏'
      this.add.visible = true
      this.add.form = {
        coverPlanUri: text.coverPlanUri,
        name: text.name,
        version: text.version,
        remark: text.remark,
        enabled: text.enabled,
        uri: text.uri,
        id: text.id,
        gameType: text.gameType,
        maxUser: text.maxUser,
        minUser: text.minUser,
      }
    },

    changeIcon(info) {
      if (info.fileList[0].response) {
        this.add.form.coverPlanUri = info.fileList[0].response.data
      }
      if (info.file.status === 'uploading') {
        this.iconloading = true
        this.imgLoading = true
        return
      }
      if (info.file.status === 'done') {
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.add.form.coverPlanUri = info.file.response.data
          this.iconloading = false
          this.imgLoading = false
          this.$refs.addForm.validateField('coverPlanUri')
        })
      }
    },
    beforeIcon(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('请上传 jpg 或者 png 图片!')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2M!')
      }
      this.add.form.coverPlanUri = ''
      return isJpgOrPng && isLt2M
    },
    Submit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let params = {
            type: this.currentType,
            ...this.add.form,
          }
          console.log(params)
          this.addOrEdit(params)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    cancelSubmit() {
      this.add.visible = false
      this.$refs.addForm.resetFields()
      this.add.confirmLoading = false
      this.add.form = {
        coverPlanUri: '',
        name: '',
        version: '',
        remark: '',
        enabled: true,
        minUser: 1,
        maxUser: 1,
        gameType: 1,
      }
    },
    addOrEdit(params) {
      this.add.confirmLoading = true
      this.$http.Brain.brainGamesEdit(params, '2.0').then((res) => {
        const { message } = res
        this.$message.destroy()
        this.cancelSubmit()
        this.$message.success(!params.id ? '添加成功' : '修改成功')
        this.getList()
      }).catch(e => {
        this.add.confirmLoading = false
      })
    },

    tableStatusChange(text) {
      this.$message.destroy()
      let formData = new FormData()
      formData.append('id', text.id)
      formData.append('status', text.enabled)
      this.tableRelevant.tableLoading = true
      this.$http.Brain.UpdateStatus(formData).then((res) => {
        this.$message.success('修改成功')
      }).finally(() => {
        this.tableRelevant.tableLoading = false
      })
    },

    deleteItem(text) {
      let formData = new FormData()
      formData.append('id', text.id)
      this.tableRelevant.tableLoading = true
      this.$http.Brain.deleteBrainGames(formData).then((res) => {
        this.getList()
        this.$message.success('删除成功')
      }).finally(() => {
        this.tableRelevant.tableLoading = false
      })
    },
  },
}
</script>

<style lang="less" scoped>
.tab .ant-card-body {
  padding-bottom: 0;
}
.iconUpload /deep/.ant-upload.ant-upload-select-picture-card {
  width: 150px;
  height: 150px;
}
.icon /deep/.ant-form-explain {
  margin-top: -20px;
}
</style>
